<template>
	<div class="form-group" :class="{ 'form-group--error' : error}">
		<fieldset class="fieldset" :aria-describedby="getId">
			<legend class="fieldset__legend fieldset__legend--xl">
				<h1>{{title}}</h1>
			</legend>
			<span :id="getId" class="hint" v-if="hintText != null">
				{{hintText}}
			</span>
			<Details v-if="detailsTitle" id="detailsId" :title="detailsTitle" :message="detailsMessage"/>
			<span v-if="error" :id="getErrorId" class="error-message">
				{{errorMessage}}
			</span>
			<slot name="content"></slot>
			<slot></slot>
		</fieldset>
	</div>
</template>

<script>
export default {
	name: 'CheckList',
	props: {
		id: String,
		title: String,
		hintText: String,
    detailsTitle: String,
    detailsMessage: String,
		error: Boolean,
		errorMessage: String,
	},
	data() {
		return {
			getError: this.error ? "form-group--error" : null,
			getErrorId: this.id + "-error",
			getId: this.id + "-hint",
		}
	}
}
</script>